const faqs = [
  {
    question: "What size air conditioner do I need for a Southern Highlands home?",
    answer: "It depends far more on your winter heating load than on floor area alone. Elevation, insulation, window size and how exposed the home is to frost all change the calculation. As a rough starting point, a well-insulated 25–35m² room typically needs 3.5–5kW of heating capacity, but older Highlands homes with single glazing often need more. We provide a proper heat-load assessment on-site rather than guessing from a chart.",
  },
  {
    question: "Will a normal reverse cycle system still heat properly at -3°C?",
    answer: "A quality reverse cycle system specified for cold climates will, yes. The key is choosing a unit with genuine low-ambient heating performance and good defrost management, rather than a budget model designed around milder coastal conditions. We only recommend systems we know perform reliably on frosty Highlands mornings.",
  },
  {
    question: "Is ducted heating worth it for an older Bowral or Berrima home?",
    answer: "Often, yes — particularly if the home has multiple living areas or bedrooms that need heating through winter. Ducted reverse cycle with zoning lets you heat only the rooms in use, which suits the long heating season here better than running several separate split systems. We'll always compare ducted against a split or multi-head solution based on your actual floor plan and budget.",
  },
  {
    question: "Do you service areas outside Bowral and Mittagong?",
    answer: "Yes. Our team regularly works across Moss Vale, Berrima, Burradoo, Bundanoon, Robertson, Goulburn, Picton, Tahmoor, Bargo, Thirlmere and the surrounding Southern Highlands and Wollondilly towns. See our full coverage on the areas we service page.",
  },
  {
    question: "How much does it cost to run reverse cycle heating through a Highlands winter?",
    answer: "Running costs depend on the system's capacity, its COP at low outdoor temperatures, how well the home is insulated, and how many hours per day it's used. A correctly sized, efficient system will generally cost noticeably less to run than an undersized unit or older gas or electric heaters, because it isn't constantly working at maximum output just to keep up. We include realistic running-cost guidance with every quote.",
  },
  {
    question: "Can I get finance for a new heating and cooling system?",
    answer: "Yes, we offer flexible interest-free finance options on eligible installations so you can invest in a properly sized system without paying the full cost upfront. Full details and eligibility are on our finance options page.",
  },
  {
    question: "How often should a ducted or split system be serviced in a cold climate?",
    answer: "We recommend an annual service before the heavy heating season begins, ideally in autumn. Systems working hard through a Highlands winter accumulate more wear on components like the outdoor fan motor and defrost sensors, and a pre-winter service catches small issues before they turn into a mid-winter breakdown.",
  },
  {
    question: "What brands do you recommend for cold-climate performance?",
    answer: "We install and service a range of leading brands and select specific models within each range based on verified low-ambient heating performance rather than brand name alone. You can see the manufacturers we work with on our brands page, and we're happy to explain why we've recommended a particular model for your property.",
  },
  {
    question: "Do heritage-listed or older homes need a different approach?",
    answer: "Often, yes. Heritage cottages and older weatherboard homes typically have less insulation, single glazing and draughtier construction than modern builds, which increases heat loss. We factor this into system sizing and will flag where sealing gaps or adding insulation would improve comfort more than a bigger unit would.",
  },
  {
    question: "How do I get a quote for my property?",
    answer: "The fastest way is to book a free on-site assessment through our schedule a quote page, or call us directly on 0480 841 485. We'll assess your home's construction, elevation and heating needs before recommending a system, rather than quoting over the phone from guesswork.",
  },
];

const HomeLocalFAQ = () => {
  return (
    <section className="py-16 md:py-20 px-4 bg-background">
      <div className="container mx-auto max-w-4xl">
        <h2 className="text-3xl md:text-4xl font-black text-foreground mb-4 uppercase tracking-wide">
          Southern Highlands Heating &amp; Cooling FAQs
        </h2>
        <p className="text-muted-foreground text-lg mb-8">
          Answers to the questions we hear most from homeowners across Mittagong, Bowral, Moss Vale
          and the wider Southern Highlands. Have a different question? Get in touch via our{" "}
          <a href="/contact-us" className="text-primary hover:underline font-semibold">contact us</a> page.
        </p>

        <div className="space-y-6">
          {faqs.map((faq) => (
            <div key={faq.question} className="border-b border-border pb-6 last:border-none">
              <h3 className="text-lg font-bold text-foreground mb-2">{faq.question}</h3>
              <p className="text-muted-foreground leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map((faq) => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
};

export default HomeLocalFAQ;
